import { isApiClientError } from "@imi/api-client/ApiClientError.js";
import { Button } from "@imi/ui/components/Button/Button.js";
import { DialogActions } from "@imi/ui/components/Dialog/DialogActions.js";
import { DialogBody } from "@imi/ui/components/Dialog/DialogBody.js";
import { DialogClose } from "@imi/ui/components/Dialog/DialogClose.js";
import { DialogCloseButton } from "@imi/ui/components/Dialog/DialogCloseButton.js";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import styles from "./DialogErrorFallback.module.css";

export function DialogErrorFallback({
  error,
  resetErrorBoundary,
}: FallbackProps) {
  const { reset: resetQueries } = useQueryErrorResetBoundary();
  const { t } = useTranslation("dialogs");

  function getErrorMessage() {
    if (isApiClientError(error)) {
      if (error.status === 404) {
        return t("error.notFound");
      }
      return t("error.apiClientError", { reason: error.reason });
    }
    return t("error.genericError");
  }

  return (
    <>
      <DialogBody className={styles.DialogErrorFallback}>
        <p>{getErrorMessage()}</p>
      </DialogBody>

      <DialogActions className={styles.DialogActions}>
        <DialogClose variant="outline">{t("error.cancel")}</DialogClose>
        <Button
          onClick={() => {
            resetQueries();
            resetErrorBoundary();
          }}
        >
          {t("error.retry")}
        </Button>
      </DialogActions>
      <DialogCloseButton>{t("error.close")}</DialogCloseButton>
    </>
  );
}
